import { render, staticRenderFns } from "./ContentPageInvers.vue?vue&type=template&id=67b76f01&lang=pug"
import script from "./ContentPageInvers.vue?vue&type=script&lang=js"
export * from "./ContentPageInvers.vue?vue&type=script&lang=js"
import style0 from "./ContentPageInvers.vue?vue&type=style&index=0&id=67b76f01&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports